import { Microservice } from "./microservice";

export class BobRequest {

	public status: number;
	public html: string;
	public headers: object;
	public microservices: Microservice[] = [];

	constructor(status: number, html: string, headers: object) {

		this.status = status;
		this.html = html;
		this.headers = headers;
	}

	public setHtml(html: string): void {

		this.html = html;
	}

	public addMicroService(MicroServiceURL: Microservice) {

		this.microservices.push(MicroServiceURL);
	}
}
